import ExtendableError from 'es6-error';

class TimeoutError extends ExtendableError {
    constructor(timeout) {
        super(`Timeout after ${timeout} ms`);
        this.timeout = timeout;
    }
}

export default TimeoutError;
